import { configureStore } from '@reduxjs/toolkit';
import jsonVisualiserReducer from '../common/slices/JSONVisualizerStateSlice';
export var uiCommonsLibStore = configureStore({
    reducer: {
        jsonVisualiserState: jsonVisualiserReducer,
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RvcmUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL2FwcC9zdG9yZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsY0FBYyxFQUFFLE1BQU0sa0JBQWtCLENBQUM7QUFFbEQsT0FBTyxxQkFBcUIsTUFBTSwyQ0FBMkMsQ0FBQztBQUU5RSxNQUFNLENBQUMsSUFBTSxpQkFBaUIsR0FBRyxjQUFjLENBQUM7SUFDOUMsT0FBTyxFQUFFO1FBQ1AsbUJBQW1CLEVBQUUscUJBQXFCO0tBQzNDO0NBQ0YsQ0FBQyxDQUFDIn0=